import {gql} from "@irati/utils/gql"

import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query BusinessRestrictions($businessId: ID!) {
    businessRestrictions(businessId: $businessId) {
      hasMaxUserLimit
      maxUsersLimit
      currentNumberOfUsers
    }
  }
`

export const businessRestrictionsKey = getQueryNames(query)[0]

export default query
